export const currency = (n, digits = 2) =>
  `$${Number(n).toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;

export const formatBedsBaths = (beds, baths) => {
  const bathLabel = baths === 1 ? '1 Bath' : `${Number.isInteger(baths) ? baths : baths.toFixed(1)} Baths`;
  if (beds === 0) return `Studio | ${bathLabel}`;
  return `${beds === 1 ? '1 Bed' : `${beds} Beds`} | ${bathLabel}`;
};

export const formatTermLabel = term => `${term.term} Months — ${currency(term.effectiveRent, 2)}/mo`;

export const formatUnitLabel = unit => `Unit ${unit.unitNumber} · ${formatBedsBaths(unit.bedrooms, unit.bathrooms)}`;

export const findUnit = (units, unitNumber) => units.find(u => u.unitNumber === unitNumber) ?? null;

export const findTerm = (unit, term) => {
  if (!unit || term == null || term === '') return null;
  return unit.matchedTerms.find(t => String(t.term) === String(term)) ?? null;
};

export const minMoveInDate = (unit, today) => (unit?.madeReadyDate && unit.madeReadyDate > today ? unit.madeReadyDate : today);

export const isoToday = () => new Date().toISOString().slice(0, 10);

export const resolveSelection = ({ units, unitNumber, term, moveInDate }) => {
  const unit = findUnit(units ?? [], unitNumber);
  const matched = findTerm(unit, term);
  return {
    unit,
    term: matched,
    canSave: Boolean(unit && matched && moveInDate),
  };
};

export const canCancelApplication = ({ submission_status, lease_id, finalization_state } = {}) => {
  if (!['pending', 'submitted', 'pending_resubmit'].includes(submission_status)) return false;
  if (lease_id) return false;
  if (finalization_state === 'finalized' || finalization_state === 'finalizing') return false;
  return true;
};

export const FINALIZE_POLL_MS = 2000;
export const FINALIZE_POLL_TIMEOUT_MS = 120000;

export const isFinalizeSettled = (application = {}) =>
  Boolean(application.lease_id) || application.finalization_state === 'finalized' || application.finalization_state === 'finalize_failed';

export const shouldPollApplication = (application, queuedAt, now = Date.now()) => {
  if (!application || isFinalizeSettled(application)) return false;
  if (application.finalization_state === 'finalizing') return true;
  if (!queuedAt) return false;
  return now - queuedAt < FINALIZE_POLL_TIMEOUT_MS;
};

export const applySelectionToApplication = (application, selection) => {
  if (!application || !selection) return application;
  return {
    ...application,
    unit: selection.unit ?? application.unit,
    move_in_date: selection.moveInDate ?? application.move_in_date,
    term: selection.term ?? application.term,
    rent: selection.rent ?? application.rent,
    ...(selection.finalizeEnqueued && !isFinalizeSettled(application) ? { finalization_state: 'finalizing' } : {}),
  };
};
